<template>
	<svg
		class="check-icon-filled"
		:class="{'disabled': disabled}"
		xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 7.4083332 7.4083335" version="1.1" id="svg8" @click="$emit('click')">
		<g id="layer1" transform="translate(0,-289.59165)">
			<g id="g3727" transform="matrix(0.21154703,0,0,0.19998395,87.378041,52.028242)" style="fill:none;fill-rule:evenodd">
				<g id="g3725">
					<g id="g3723" style="fill:none;fill-rule:nonzero" transform="matrix(2.1012503,0,0,2.1012503,-408.93768,-254.09734)">
						<g id="g3838" transform="matrix(0.59522034,0,0,0.629636,84.148107,554.34426)" style="fill:none;fill-rule:evenodd">
							<g id="g3836" transform="translate(-608.11183,90.91373)">
								<g id="g3834" style="fill-rule:nonzero">
									<g id="g3828" transform="matrix(1.8095238,0,0,1.8095238,-496.57469,46.837271)">
										<circle
											id="circle3826" stroke-linejoin="square" r="7" cy="47.464161" cx="538.33514" style="fill-rule:evenodd;"
											:style="{fill: this.themeColor, stroke: this.themeColor}"
										/>
									</g>
									<g id="g3832" style="fill:#ffffff" transform="matrix(1.8095238,0,0,1.8095238,-496.57469,46.837271)">
										<path id="path3830" d="m 540.31402,45.544371 -3.217,3.216 -0.873,-0.873 c -0.318,-0.318 -0.834,-0.318 -1.153,0 -0.318,0.318 -0.318,0.835 0,1.153 l 1.451,1.45 c 0.16,0.159 0.368,0.238 0.576,0.238 0.209,0 0.418,-0.08 0.577,-0.239 l 3.793,-3.793 c 0.318,-0.318 0.318,-0.834 0,-1.152 -0.319,-0.319 -0.835,-0.319 -1.153,0 z" inkscape:connector-curvature="0"/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'check-icon-filled',
	props: ['disabled', 'color'],
	computed: {
		themeColor() {
			return `var(--app-color-${this.color || 'primary'})`;
		},
	},
};
</script>

<style lang="scss" scoped>
.check-icon-filled {
	&.disabled {
		circle {
			fill: var(--app-color-gray) !important;
			stroke: var(--app-color-gray) !important;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/icons/check-icon-filled.vue